import React from "react";

import Manual from "../../../templates/Select/Manual";

const ManualPage = () => {
  return <Manual />;
};

export default ManualPage;
